((Drupal, once) => {
  Drupal.behaviors.sidebar = {
    attach: (context, settings) => {
      let activeSidebar;

      function isClicksOutsideSidebar(e) {
        if (activeSidebar === !e.target || !activeSidebar.contains(e.target)) {
          closeSidebar();
        }
      }

      function openSidebar(e, sidebar) {
        e.stopPropagation();

        if (activeSidebar) {
          activeSidebar.classList.remove('is-active', 'is-outside-horizontal');
        }

        activeSidebar = sidebar;
        document.addEventListener('click', isClicksOutsideSidebar);
      }

      function closeSidebar() {
        if (activeSidebar) {
          activeSidebar = null;
          document.querySelector('.cart-button__link').click();
          document.removeEventListener('click', isClicksOutsideSidebar);
        }
      }
      const openCartButton = once('sidebar', '.cart-button__link', context)[0];
      const closeSidebarButton = once('sidebar', '.close-sidebar', context)[0];
      const continueShoppingButton = once(
        'sidebar',
        '.button-continue-shopping',
        context,
      )[0];
      const cartSidebar = once('sidebar', '.cart-block--contents', context)[0];

      if (openCartButton) {
        openCartButton.addEventListener('click', (e) => {
          openSidebar(e, cartSidebar);
        });
      }

      if (closeSidebarButton) {
        closeSidebarButton.addEventListener('click', closeSidebar);
      }

      if (continueShoppingButton) {
        continueShoppingButton.addEventListener('click', closeSidebar);
      }
    },
  };
})(Drupal, once);
